import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import EmployeeResult from './EmployeeResult.jsx';
import BranchResult from './BranchResult.jsx';
import FontAwesome from 'react-fontawesome';
import { FormattedMessage } from 'react-intl';
import {Screens} from '../constants/screens.mjs';
import {FlowSteps} from '../constants/flowSteps.mjs';
import {LoginFlowScreenPropTypes} from '../../../shapes/index.mjs';

const LoginScreen = ({changeScreen, loginEmployee, loginFlowChanged, selectedEmployee, processing, onCancel}) => {
  const cssBEM = 'login-screen';
  const { branches } = selectedEmployee || {};
  const [ selectedBranch, setSelectedBranch ] = useState(false);
  useEffect( () => {
    if(branches && branches.length === 1 && !selectedBranch){
      loginFlowChanged(FlowSteps.BRANCH_SELECTED);
      setSelectedBranch(branches[0]);
    }
  }, [branches]);

  const loginClicked = () => {
    loginFlowChanged(FlowSteps.LOGGED_IN);
    loginEmployee({
      employee: selectedEmployee,
      branch: selectedBranch
    });
  };

  const editClicked = () => {
    changeScreen(Screens.EDIT);
  };

  const branchList = (selectedEmployee.branches || []).map(branch => {
    const selected = selectedBranch && selectedBranch.id === branch.id;
    const className = selected ? 'selected' : '';
    const children = selected ? <FontAwesome name="check"/> : null;

    return <BranchResult
      key={branch.id}
      className={className}
      onClick={() => { setSelectedBranch(branch); loginFlowChanged(FlowSteps.BRANCH_SELECTED); }}
      branch={branch}
    >
      {children}
    </BranchResult>;
  });

  const employeeDetailsRender = <div className={`${cssBEM}__employee`}>
    { selectedEmployee.id ? <EmployeeResult employee={selectedEmployee} /> : null }
    <div className={`${cssBEM}__branches`}>
      <FormattedMessage id="employeeLogin.login.branchList" tagName="label"/>
      <div className="login-branches">{branchList}</div>
      { !selectedBranch
        ? <div className={`${cssBEM}__branch-list-alert`}><i className="fa fa-exclamation-triangle" /> <FormattedMessage id="employeeLogin.login.branchList.alert" tagName="span"/></div>
        : null
      }
    </div>
  </div>;

  return <section className={cssBEM}>
    <FormattedMessage id="employeeLogin.login.help" tagName="p" />

    { processing ? null : employeeDetailsRender }

    <div className="screen-actions">
      <button onClick={onCancel} className="screen-actions__btn screen-actions__btn--float-left screen-actions__btn--cancel">
        <FormattedMessage id="employeeLogin.cancel" />
      </button>

      <button onClick={loginClicked} className="screen-actions__btn screen-actions__btn--float-right" disabled={!selectedBranch || processing}>
        <FormattedMessage id="employeeLogin.login" />
      </button>
      <button onClick={editClicked} className="screen-actions__btn screen-actions__btn--float-right screen-actions__btn--secondary" disabled={processing}>
        <FormattedMessage id="employeeLogin.edit" />
      </button>
    </div>
  </section>;
};

LoginScreen.propTypes = {
  ...LoginFlowScreenPropTypes,
  loginEmployee: PropTypes.func.isRequired,
  selectedEmployee: PropTypes.object.isRequired
};

export default LoginScreen;
